// 拼音搜索工具函数

// 简化版拼音映射表（包含常用汉字与拼音对应关系）
const pinyinMap = {
  'a': '啊阿锕嗄吖呵腌錒',
  'ai': '爱埃碍矮挨唉哎哀皑癌蔼艾隘',
  'an': '安按暗岸案俺氨胺鞍铵谙庵',
  'ang': '昂盎肮',
  'ao': '奥澳傲熬凹敖袄懊坳嗷',
  'ba': '把八吧巴爸罢拔叭芭霸靶扒疤',
  'bai': '百白败摆伯拜柏佰掰',
  'ban': '办半版般班板伴搬扮颁斑瓣绊',
  'bang': '帮棒邦榜膀绑傍磅蚌',
  'bao': '报保包暴宝抱薄胞爆炮饱褒',
  'bei': '被北备背悲辈杯倍贝碑卑',
  'ben': '本奔笨苯',
  'beng': '崩绷甭泵蹦迸嘣',
  'bi': '比必避闭辟笔彼逼币鼻毕',
  'bian': '变边便遍编辩鞭贬扁卞辨',
  'biao': '表标彪膘婊飙镖骠镳杓',
  'bie': '别憋瘪鳖',
  'bin': '宾滨彬斌缤濒鬓殡',
  'bing': '并病兵冰屏饼炳秉丙柄',
  'bo': '波播博伯勃薄拨泊柏',
  'bu': '不步布部捕卜簿埠埔堡',
  'ca': '擦嚓',
  'cai': '才采菜财材彩裁猜蔡',
  'can': '参残蚕灿惭惨孱餐骖璨',
  'cang': '藏仓苍舱沧',
  'cao': '草操曹槽糙嘈漕',
  'ce': '测策侧册厕恻',
  'ceng': '层曾蹭噌',
  'cha': '查差插察茶叉茬碴搽岔诧',
  'chai': '拆柴豺侪钗瘥虿',
  'chan': '产铲阐搀掺蝉馋谗缠',
  'chang': '长常场厂唱昌倡肠畅',
  'chao': '超朝潮吵炒钞抄嘲',
  'che': '车彻撤尺扯澈掣坼砗',
  'chen': '陈沉称衬尘臣晨郴辰',
  'cheng': '成程城承乘呈撑澄秤瞠',
  'chi': '持吃尺迟齿赤翅斥',
  'chong': '重冲充崇虫宠憧忡',
  'chou': '抽仇臭酬畴踌稠愁筹',
  'chu': '出处础初楚触矗橱',
  'chuai': '揣搋踹啜膪',
  'chuan': '传川船穿串喘椽舛遄',
  'chuang': '创窗床闯幢疮',
  'chui': '吹垂锤炊捶陲棰槌',
  'chun': '春纯醇淳唇椿蠢',
  'chuo': '戳绰啜辍踔龊',
  'ci': '次此差刺辞慈磁赐瓷',
  'cong': '从丛聪葱囱匆苁淙',
  'cou': '凑楱辏腠',
  'cu': '粗促醋簇蹙蹴猝蔟殂',
  'cuan': '窜蹿篡攒撺',
  'cui': '催脆摧翠崔淬瘁粹',
  'cun': '存村寸蹲忖皴',
  'cuo': '错措搓挫撮磋蹉嵯',
  'da': '大打达答搭瘩',
  'dai': '带代呆戴待袋逮歹傣',
  'dan': '但单蛋担弹掸胆淡丹耽',
  'dang': '当党挡档荡谠凼菪宕',
  'dao': '到道导倒刀岛盗稻捣悼',
  'de': '的得德底锝',
  'deng': '等登灯邓凳瞪澄蹬',
  'di': '地第底低敌抵滴帝',
  'dian': '点电店典奠甸碘淀颠',
  'diao': '调掉雕吊钓刁貂',
  'die': '爹跌叠碟蝶谍踮',
  'ding': '顶定盯订钉丁鼎',
  'diu': '丢铥',
  'dong': '动东懂洞冻冬董栋侗恫',
  'dou': '都斗豆抖逗陡兜窦',
  'du': '读度毒渡堵独肚督嘟',
  'duan': '段短断缎椴煅锻簖',
  'dui': '对队堆兑敦碓',
  'dun': '吨顿蹲墩盾钝遁',
  'duo': '多夺朵舵剁垛堕惰',
  'e': '饿哦额鹅蛾扼俄',
  'en': '恩摁蒽',
  'er': '而二耳儿饵尔贰',
  'fa': '发法罚伐乏筏阀珐',
  'fan': '反饭翻番繁犯凡帆',
  'fang': '方放房防访纺芳仿坊',
  'fei': '非飞肥费肺废沸费',
  'fen': '分份芬粉坟奋酚吩',
  'feng': '风封峰丰疯锋蜂枫',
  'fo': '佛',
  'fou': '否缶',
  'fu': '复服副府夫负富附',
  'ga': '夹嘎尬噶尕旮钆',
  'gai': '改该盖概钙芥溉垓陔戤',
  'gan': '干杆感敢赶甘肝秆',
  'gang': '刚钢缸纲岗港杠冈',
  'gao': '高搞告膏篙皋羔糕镐睾',
  'ge': '个各革合格哥歌隔',
  'gei': '给',
  'gen': '跟根哏茛亘艮',
  'geng': '更耕颈庚羹埂耿梗哽赓鲠',
  'gong': '工公功共弓巩拱贡汞',
  'gou': '够构沟狗钩勾购苟垢',
  'gu': '古股鼓谷故孤',
  'gua': '挂刮瓜寡剐褂卦呱栝鸹',
  'guai': '怪拐乖掴',
  'guan': '关管观官馆惯冠贯罐',
  'guang': '光广逛咣犷桄胱',
  'gui': '规贵归鬼桂柜跪轨',
  'gun': '滚棍辊衮',
  'guo': '过国果裹锅郭涡埚椁聒',
  'ha': '哈蛤虾铪呵',
  'hai': '还海害咳氦孩骇骸亥嗨',
  'han': '含焊旱喊汉寒汗韩',
  'hang': '行航杭巷夯吭沆绗颃',
  'hao': '好号浩耗毫豪壕嚎',
  'he': '和合河何核盒喝贺荷褐',
  'hei': '黑嘿嗨',
  'hen': '很狠恨痕哏',
  'heng': '横恒哼衡',
  'hong': '红宏洪轰虹鸿弘',
  'hou': '后候厚侯喉猴吼堠後逅瘊篌',
  'hu': '互湖户护呼胡糊',
  'hua': '化花话划滑华哗猾豁',
  'huai': '坏怀淮槐徊踝',
  'huan': '还环换欢缓幻患唤焕',
  'huang': '黄簧荒皇慌蝗磺凰',
  'hui': '回会灰绘挥汇辉',
  'hun': '混昏荤浑婚魂馄珲',
  'huo': '或活火伙货获祸',
  'ji': '几及急既即机鸡积基',
  'jia': '加家假价架甲佳夹嘉',
  'jian': '见件减尖间贱肩兼建检',
  'jiang': '将讲江奖降浆蒋姜',
  'jiao': '教交焦叫脚胶轿骄',
  'jie': '接节街借皆截解界结届',
  'jin': '进金近仅紧尽津斤',
  'jing': '经京精境竟静惊景敬',
  'jiong': '窘炯迥炅冂',
  'jiu': '就九酒旧久揪救纠舅',
  'ju': '句举巨局具距惧',
  'juan': '卷捐鹃娟倦眷绢鄄',
  'jue': '决绝觉角掘诀撅攫崛厥',
  'jun': '军均君峻',
  'ka': '卡咯咖喀咔佧胩',
  'kai': '开揩凯慨楷',
  'kan': '看砍堪刊嵌坎勘龛戡',
  'kang': '抗炕扛糠康慷',
  'kao': '考靠拷烤铐犒',
  'ke': '可克科客刻课颗渴棵',
  'ken': '肯啃垦恳',
  'keng': '坑吭铿',
  'kong': '空控孔恐倥崆箜',
  'kou': '口扣寇叩抠佝蔻芤',
  'ku': '哭库苦枯酷裤窟',
  'kua': '跨夸垮挎胯侉',
  'kuai': '快块筷会侩哙蒯浍郐',
  'kuan': '款宽髋',
  'kuang': '矿狂框况旷匡眶',
  'kui': '亏愧奎窥溃葵魁馈',
  'kun': '困昆坤鲲锟醌琨',
  'kuo': '阔扩廓适蛞',
  'la': '拉啦蜡腊喇垃',
  'lai': '来赖莱崃徕涞濑赉睐铼',
  'lan': '兰烂蓝览栏懒拦篮',
  'lang': '浪朗郎狼琅榔廊',
  'lao': '老劳捞牢姥佬潦',
  'le': '了乐勒肋仂叻泐鳓',
  'lei': '类累雷勒垒泪镭蕾磊',
  'leng': '冷棱楞愣',
  'li': '里理力利立离例丽',
  'lia': '俩',
  'lian': '连联练炼脸链敛怜莲镰廉',
  'liang': '两亮量良辆梁粮粱',
  'liao': '了料撩聊燎疗僚',
  'lie': '列烈裂劣猎咧趔冽洌鬣',
  'lin': '林临淋邻琳',
  'ling': '另令领零灵岭铃陵',
  'liu': '流留刘硫柳六旒',
  'long': '龙隆弄垄笼窿咙',
  'lou': '楼漏搂喽篓陋偻蝼镂蒌',
  'lu': '路露录陆炉鹿碌',
  'luan': '乱卵峦孪挛栾銮滦',
  'lun': '论轮伦沦仑抡囵',
  'luo': '落罗锣裸骡烙螺络',
  'lv': '率律旅绿虑',
  'ma': '吗妈马嘛',
  'mai': '买卖迈埋麦脉',
  'man': '满慢瞒漫蛮蔓曼',
  'mang': '忙盲茫氓芒莽蟒邙',
  'mao': '毛冒猫贸矛帽',
  'me': '么麽',
  'mei': '没每美妹眉梅',
  'men': '们门闷扪焖懑',
  'meng': '猛梦蒙锰',
  'mi': '米密迷眯蜜谜',
  'mian': '面棉免绵缅勉',
  'miao': '秒苗庙妙瞄藐渺',
  'mie': '灭蔑咩篾蠛',
  'min': '民抿敏闽皿悯闵',
  'ming': '名明命鸣铭冥茗溟',
  'miu': '谬缪',
  'mo': '摸磨抹末默',
  'mou': '某谋牟眸哞鍪蛑侔',
  'mu': '木母模',
  'na': '那拿哪',
  'nai': '耐奶乃氖奈鼐艿萘',
  'nan': '南难男楠喃腩囡',
  'nang': '囊馕攮',
  'nao': '闹脑恼挠瑙淖孬垴铙',
  'ne': '呢哪讷',
  'nei': '内那',
  'nen': '嫩恁',
  'neng': '能',
  'ni': '你尼呢泥',
  'nian': '年念粘',
  'niang': '娘酿',
  'niao': '鸟尿袅茑嬲脲',
  'nie': '捏聂啮涅嗫镊镍',
  'nin': '您恁',
  'ning': '宁凝拧泞咛狞柠',
  'niu': '牛扭纽钮狃忸妞',
  'nong': '农浓弄脓侬哝',
  'nu': '怒奴努',
  'nuan': '暖暧煖',
  'nuo': '诺挪懦糯',
  'nv': '女钕',
  'o': '哦噢喔',
  'ou': '欧偶殴呕',
  'pa': '怕爬帕扒趴啪',
  'pai': '派排拍牌迫徘湃',
  'pan': '盘判盼叛畔',
  'pang': '旁胖庞乓膀磅彷螃',
  'pao': '跑抛炮泡刨袍咆',
  'pei': '配培陪赔佩沛坏',
  'pen': '喷盆湓',
  'peng': '碰棚',
  'pi': '批皮披匹劈',
  'pian': '片偏篇骗扁骈',
  'piao': '票飘漂瓢嫖',
  'pie': '瞥撇苤氕丿',
  'pin': '品贫聘拼频',
  'ping': '平评凭瓶屏乒坪萍',
  'po': '破坡颇婆泼',
  'pou': '剖掊裒',
  'pu': '普铺扑朴',
  'qi': '起其七气期齐妻',
  'qia': '恰卡洽掐髂袷葜',
  'qian': '前钱千签欠牵',
  'qiang': '强枪墙腔呛羌',
  'qiao': '桥悄敲巧瞧翘',
  'qie': '切且窃怯茄趄妾',
  'qin': '亲琴侵勤擒芹',
  'qing': '请轻清青倾',
  'qiong': '穷琼穹茕',
  'qiu': '求球秋丘邱囚',
  'qu': '去取区娶曲',
  'quan': '全权劝圈拳',
  'que': '却缺确雀鹊炔阙榷',
  'qun': '群裙逡麇',
  'ran': '然染燃冉苒',
  'rang': '让壤攘嚷',
  'rao': '绕扰饶娆桡荛',
  're': '热惹喏',
  'ren': '人认任忍',
  'reng': '仍扔',
  'ri': '日',
  'rong': '容绒融溶熔荣戎',
  'rou': '肉揉柔蹂鞣',
  'ru': '如入汝儒蠕',
  'ruan': '软阮朊',
  'rui': '瑞锐蕊芮睿蚋',
  'run': '润闰',
  'ruo': '若弱',
  'sa': '撒洒萨',
  'sai': '赛塞腮鳃',
  'san': '三散伞叁馓',
  'sang': '桑丧嗓搡磉颡',
  'sao': '扫嫂搔骚梢埽臊缫瘙',
  'se': '色涩瑟塞啬穑铯',
  'sen': '森',
  'seng': '僧',
  'sha': '杀沙啥纱傻砂',
  'shai': '晒筛色酾',
  'shan': '山善闪衫',
  'shang': '上商伤赏',
  'shao': '少烧捎稍勺哨',
  'she': '社设射摄舍涉赦',
  'shen': '身伸深神审申甚',
  'sheng': '生省升声胜盛',
  'shi': '是时实事市十',
  'shou': '手受收首守',
  'shu': '数书树属',
  'shua': '刷耍唰',
  'shuai': '摔甩帅衰率蟀',
  'shuan': '栓拴闩涮',
  'shuang': '双霜爽孀',
  'shui': '水谁税睡',
  'shun': '顺吮瞬舜',
  'shuo': '说烁硕朔搠妁槊蒴',
  'si': '思四死似',
  'song': '送松宋',
  'sou': '搜艘嗖嗽擞馊薮',
  'su': '速素苏',
  'suan': '算酸蒜狻',
  'sui': '虽随岁碎',
  'sun': '孙损笋荪狲飧',
  'suo': '所缩锁琐索梭唆嗦嗍娑',
  'ta': '他它她塔',
  'tai': '太抬台态',
  'tan': '谈探弹坦',
  'tang': '堂糖汤躺',
  'tao': '套讨逃桃',
  'te': '特忑慝铽',
  'teng': '疼腾藤誊滕',
  'ti': '提题体替',
  'tian': '天田添',
  'tiao': '条跳调挑',
  'tie': '铁贴帖萜餮',
  'ting': '听停庭挺',
  'tong': '同通痛铜桶',
  'tou': '头偷透',
  'tu': '图土突徒',
  'tuan': '团湍抟彖疃',
  'tui': '推退腿颓蜕褪',
  'tun': '吞屯囤褪豚臀氽',
  'tuo': '托脱拖妥',
  'wa': '挖瓦蛙哇娃',
  'wai': '外歪崴',
  'wan': '完万晚',
  'wang': '望王往网忘',
  'wei': '为位委未维',
  'wen': '问温文闻',
  'weng': '翁嗡瓮蓊',
  'wo': '我握窝',
  'wu': '无五物武务误',
  'xi': '系西息希席',
  'xia': '下夏吓',
  'xian': '先线县现显',
  'xiang': '想向相象',
  'xiao': '小笑消削',
  'xie': '些写协斜',
  'xin': '新心信',
  'xing': '行性形兴',
  'xiong': '雄胸凶兄熊',
  'xiu': '修休秀袖宿',
  'xu': '许须需虚',
  'xuan': '选悬宣旋',
  'xue': '学血雪削',
  'xun': '训讯迅寻',
  'ya': '压亚呀牙',
  'yan': '眼言严演研烟',
  'yang': '样养央阳',
  'yao': '要摇药咬',
  'ye': '也业夜',
  'yi': '一以已义意议医易',
  'yin': '因引印',
  'ying': '应英影营迎',
  'yo': '哟育唷',
  'yong': '用勇永拥涌',
  'you': '有又由右油游',
  'yu': '与于语育遇',
  'yuan': '员原圆',
  'yue': '月越约',
  'yun': '云运晕',
  'za': '杂砸咋匝咂拶',
  'zai': '在再灾载',
  'zan': '咱暂赞',
  'zang': '脏葬赃藏臧',
  'zao': '早造遭糟',
  'ze': '则责择',
  'zei': '贼',
  'zen': '怎谮',
  'zeng': '增赠憎曾',
  'zha': '炸渣查扎',
  'zhai': '摘窄斋寨',
  'zhan': '站占战展',
  'zhang': '张章长掌',
  'zhao': '找照招赵',
  'zhe': '着这者折',
  'zhen': '真阵镇针',
  'zheng': '正整政争',
  'zhi': '之只知至',
  'zhong': '中重种众',
  'zhou': '周洲州皱',
  'zhu': '主住注祝',
  'zhua': '抓挝爪',
  'zhuai': '拽',
  'zhuan': '专转赚',
  'zhuang': '装庄撞',
  'zhui': '追坠缀锥',
  'zhun': '准谆肫窀',
  'zhuo': '着桌捉',
  'zi': '字自子',
  'zong': '总宗纵',
  'zou': '走奏邹揍',
  'zu': '组族足阻',
  'zuan': '钻纂攥缵躜',
  'zui': '最罪嘴醉',
  'zun': '尊遵樽鳟',
  'zuo': '做作坐左座'
};

// 将汉字转换为拼音
function convertToPinyin(text) {
  let result = '';
  
  for (let char of text) {
    // 如果是英文或数字，直接添加
    if (/[a-zA-Z0-9]/.test(char)) {
      result += char.toLowerCase();
      continue;
    }
    
    // 查找汉字对应的拼音
    let found = false;
    for (let pinyin in pinyinMap) {
      if (pinyinMap[pinyin].includes(char)) {
        result += pinyin;
        found = true;
        break;
      }
    }
    
    // 如果没找到对应拼音，原样保留
    if (!found) {
      result += char;
    }
  }
  
  return result;
}

// 提取拼音首字母
function getPinyinInitials(text) {
  const pinyin = convertToPinyin(text);
  let initials = '';
  
  // 提取每个拼音的首字母
  let i = 0;
  while (i < pinyin.length) {
    // 如果是字母，则可能是拼音的开始
    if (/[a-z]/.test(pinyin[i])) {
      initials += pinyin[i];
      
      // 跳过整个拼音
      let j = i + 1;
      while (j < pinyin.length && /[a-z]/.test(pinyin[j])) {
        j++;
      }
      i = j;
    } else {
      // 非字母字符直接保留
      initials += pinyin[i];
      i++;
    }
  }
  
  return initials;
}

// 拼音搜索函数
function pinyinSearch(searchTerm, items, fields = ['title', 'content']) {
  if (!searchTerm || searchTerm.trim() === '') {
    return items;
  }
  
  const searchTermLower = searchTerm.toLowerCase();
  const searchTermPinyin = convertToPinyin(searchTerm);
  const searchTermInitials = getPinyinInitials(searchTerm);
  
  return items.filter(item => {
    return fields.some(field => {
      if (!item[field]) return false;
      
      const fieldValue = String(item[field]).toLowerCase();
      const fieldPinyin = convertToPinyin(item[field]);
      const fieldInitials = getPinyinInitials(item[field]);
      
      // 直接匹配
      if (fieldValue.includes(searchTermLower)) {
        return true;
      }
      
      // 拼音全拼匹配
      if (fieldPinyin.includes(searchTermPinyin)) {
        return true;
      }
      
      // 拼音首字母匹配
      if (fieldInitials.includes(searchTermInitials)) {
        return true;
      }
      
      return false;
    });
  });
}

export { pinyinSearch, convertToPinyin, getPinyinInitials };